import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#041C42",
  d: "M0 2v1.647h14V2H0Zm0 4.118v1.647h14V6.118H0Zm0 4.117v1.647h14v-1.647H0Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }